
/*
需要文章里面添加锚点,且添加产品列表元字段保证有数据
<div anchor-product-handle="fiido-c11-electric-commuter-bike"></div>
旧的产品卡会通过js进行刷新内容
*/ 

// 引入自定义格式化函数custom-format-price.js
import { shopifyFormatPrice } from './custom-format-price.js';
// 定义获取最新价格的html函数
function getLatestPriceHtml(product,replace = false){
    return `<span class="sale-price" ${replace ? 'data-replace="true"' : ''}>${shopifyFormatPrice(product.price_min)}</span> ${product.compare_at_price_max ? `<span class="unline-price">${shopifyFormatPrice(product.compare_at_price_max)}</span>` : ''}`;
}
// 定义生成产品卡片函数
function generateProductCard(product) {
    // 生成html
    let product_html = `
        <div class="ap-card-box" data-auto-generate="true">
            <div class="ap-card">
                <div class="img-box">
                    <a href="${product.url}?utm_source=blog"> 
                        <img src="${product.featured_image.src}" alt="${product.featured_image.alt ? product.featured_image.alt : product.title}">      
                    </a>
                </div>
                <div class="cont-box">
                    <div class="top-box">
                        <div class="title">
                            <h3>${product.title}</h3>
                        </div>
                        <div class="price-box">
                            ${getLatestPriceHtml(product)}
                        </div>
                    </div>
                    <div class="bottom-box">
                        <div class="decr">
                            <p>${product.description}</p>
                        </div>
                        <a href="${product.url}?utm_source=blog" class="btn"> <span>${product.btn_text}</span> </a>
                    </div>
                </div>
            </div>
        </div>`;
    return product_html;
}
let card_css = `
    <style>
        .ap-card-box {
            margin: 10px auto;
        }
        .ap-card {
            width: 100%;
            height: auto;
            border-radius: 10px;
            background-color: #f7f7f7;
            padding: 20px 40px;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-between;

        }
        .ap-card>.img-box {
            max-width: 240px;
            flex: 0 0 240px;
        }

        .ap-card .cont-box {
            flex: 0 0 calc(100% - 340px);
        }

        .ap-card .btn {
            padding: 10px 20px;
            background-color: #001d35;
            border-radius: 50px;
            color: #fff !important;
            text-decoration: none !important;
            font-size: 14px;
            font-weight: 700;
            border: 1px solid transparent;
            display: inline-flex;
            text-align: center;
            margin-top: 15px;
        }

        .ap-card .btn:hover {
            border: 1px solid #001d35;
            background-color: #fff;
            color: #001d35 !important;
            font-weight: 600;
        }

        .ap-card .cont-box .price-box .sale-price {
            color: #ee0000;
            font-size: 22px;
            font-weight: 600;
        }

        .ap-card .cont-box .price-box .unline-price {
            text-decoration: line-through;
            font-size: 15px;
        }

        .ap-card .top-box {
            margin-bottom: 30px;
        }

        .ap-card .top-box h3 {
            margin-bottom: 4px;
        }

        @media all and (max-width:999px) {
            .ap-card {
                flex-direction: column;
                padding: 0 20px 20px;
            }

            .ap-card>.img-box {
                max-width: 100%;
                flex: 0 0 100%;
            }

            .ap-card .cont-box {
                flex: 0 0 100%;
                width: 100%;
            }

            .ap-card .top-box {
                margin-bottom: 20px;
            }

            .ap-card .top-box h3 {
                margin-bottom: 2px;
            }

            .ap-card .btn {
                margin-top: 10px;
            }
        }
    </style> 
`;

// 寻找有data-product-json的元素数组数据
let product_json_list = $('[data-product-json]');
// 添加css
if(product_json_list.length > 0) $('body').append(card_css);
// 寻找blog内容有anchor-product-handle="{{ product.handle }}"的元素数组
let product_card_anchor_list = $('.article__content [anchor-product-handle]');
// 判断是否有元素数组且数组长度大于0
if (product_json_list.length > 0 && product_card_anchor_list.length > 0) {
    // 循环解析生成html
    product_json_list.each(function (index, item) {
        // 解析json，添加错误处理
        let product = null;
        try {
            const jsonData = $(item).html();
            if (!jsonData || jsonData.trim() === '') {
                console.warn('Product JSON data is empty for element:', item);
                return;
            }
            product = JSON.parse(jsonData);
        } catch (error) {
            console.error('Failed to parse product JSON:', error);
            console.error('JSON data:', $(item).html());
            return;
        }

        if (!product || !product.handle) {
            console.warn('Invalid product data:', product);
            return;
        }

        // 生成html
        let product_html = generateProductCard(product);

        // 为新增的锚点元素添加产品卡片内容,改用for循环
        for (let i = 0; i < product_card_anchor_list.length; i++) {
            let anchor = product_card_anchor_list[i];
            // 当handle对应时替换锚点元素内容
            if ($(anchor).attr('anchor-product-handle') == product.handle) {
                $(anchor).replaceWith(product_html);
                product_html = '';
                break;
            }
        }
    });
}

// 以前产品卡价格dom的替换
let product_old_card_box_list = $('.article__content .ap-card-box:not([data-aute-generate="true"])');
if(product_old_card_box_list.length > 0 && product_json_list.length > 0){
    // 循环解析生成html
    product_json_list.each(function (index, item) {
        // 解析json，添加错误处理
        let product = null;
        try {
            const jsonData = $(item).html();
            if (!jsonData || jsonData.trim() === '') {
                console.warn('Product JSON data is empty for element:', item);
                return;
            }
            product = JSON.parse(jsonData);
        } catch (error) {
            console.error('Failed to parse product JSON:', error);
            console.error('JSON data:', $(item).html());
            return;
        }

        if (!product || !product.handle) {
            console.warn('Invalid product data:', product);
            return;
        }

        // 生成产品卡html
        let new_product_html = generateProductCard(product);

        // 为新增的锚点元素添加产品卡片内容,改用for循环
        for (let i = 0; i < product_old_card_box_list.length; i++) {
            let old_card_box = product_old_card_box_list[i];
            let btn_href = $(old_card_box).find('.ap-card').find('a.btn').attr('href');
            // 当handle对应时替换锚点元素内容
            if (btn_href.includes(product.handle)) {
                $(old_card_box).replaceWith(new_product_html);
                new_product_html = '';
                break;
            }
        }
    });
}
